package io.horion.cv.uiState

import io.horion.cv.api.datasource.payement.PaymentMethod

data class PaymentUiState(
    val loading: Boolean = false,
    val paymentSuccess: Boolean = false,
    val paymentSuccessLancer: Boolean = false,
    val phone : String = "",
    val downloadUrl : String = "",
    val amount : Double = 50.0,
    val method : PaymentMethod = PaymentMethod.OM,
    val error: String? = null,
    val success: String? = null,
)
